import React from 'react';
import { CellContext } from '@tanstack/react-table';

import { AdaptiveTableCell } from '@components/common';
import Actions from '@components/common/Actions';

import { IBranchesList, IBranchTable } from '@interfaces/cmModule/configurationComparison';

import { columnSizes } from '@constants/table';

import styles from '@components/common/Table/Table.module.scss';

export const getColumns = ({ openTableBranch }: { openTableBranch: (data: IBranchTable) => void }) => ([
	{
		header: 'Branch',
		accessorKey: 'distName',
		enableSorting: false,
		cell: ({ getValue }: CellContext<IBranchesList, any>) => {
			const distName = getValue();

			return <AdaptiveTableCell text={distName} />;
		},
	},
	{
		header: 'Total',
		accessorKey: 'metadata.totalNumber',
		cell: ({ getValue }: CellContext<IBranchesList, any>) => {
			const totalNumber = getValue();

			return <AdaptiveTableCell text={totalNumber} />;
		},
	},
	{
		header: 'Increased',
		accessorKey: 'metadata.increasedNumber',
		cell: ({ getValue }: CellContext<IBranchesList, any>) => {
			const increasedNumber = getValue();

			return (
				<AdaptiveTableCell
					className={styles.greenCell}
					text={increasedNumber}
				/>
			);
		},
	},
	{
		header: 'Decreased',
		accessorKey: 'metadata.decreasedNumber',
		cell: ({ getValue }: CellContext<IBranchesList, any>) => {
			const decreasedNumber = getValue();

			return (
				<AdaptiveTableCell
					className={styles.redCell}
					text={decreasedNumber}
				/>
			);
		},
	},
	{
		header: 'Missing',
		accessorKey: 'metadata.missingNumber',
		cell: ({ getValue }: CellContext<IBranchesList, any>) => {
			const missingNumber = getValue();

			return (
				<AdaptiveTableCell
					className={styles.grayCell}
					text={missingNumber}
				/>
			);
		},
	},
	{
		header: 'Others',
		accessorKey: 'metadata.otherNumber',
		cell: ({ getValue }: CellContext<IBranchesList, any>) => {
			const otherNumber = getValue();

			return (
				<AdaptiveTableCell
					className={styles.orangeCell}
					text={otherNumber}
				/>
			);
		},
	},
	{
		header: () => (
			<div className={styles.centerColumnHeader}>
				Actions
			</div>
		),
		accessorKey: 'Actions',
		enableSorting: false,
		size: columnSizes.size135,
		cell: ({ row }: CellContext<any, any>) => {
			const handleOpenTableBranch = () => openTableBranch(row.original);

			return (
				<Actions
					isOpenModal
					openModalHandler={handleOpenTableBranch}
				/>
			);
		},
	},
]);
